import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import {
  Button, ModalBody, ModalFooter, ModalHeader,
} from 'reactstrap';

import ErrorBoundary from '../ErrorBoundary';
import DownloadRequestEditReasonContent from '../DownloadRequestEdit/ReasonContent';

const DownloadReasonsModal = ({
  reason,
  handleClose,
}) => {
  const intl = useIntl();

  return (
    <ErrorBoundary>
      <ModalHeader className="modal-header-center">
        {intl.formatMessage({ defaultMessage: 'Download reason' })}
      </ModalHeader>
      <ModalBody className="download-details">
        <DownloadRequestEditReasonContent reason={reason} />
      </ModalBody>
      <ModalFooter>
        <Button onClick={handleClose}>
          {intl.formatMessage({ defaultMessage: 'Close' })}
        </Button>
      </ModalFooter>
    </ErrorBoundary>
  );
};

DownloadReasonsModal.propTypes = {
  reason: PropTypes.any.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default DownloadReasonsModal;
